/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgendarCorrecaoDto,
  AnexoDeChamadoResponse,
  CancelarChamadoDto,
  ChamadoAdminResponse,
  ChamadosAdminControllerEnviarAnexoBody,
  ChamadosAdminControllerListarMensagensParams,
  ChamadosAdminControllerListarParams,
  ConcluirChamadoDto,
  DefinirPrevisaoDto,
  DefinirUrgenciaDto,
  EnviarMensagemChamadoAdminDto,
  ErroResponse,
  ListaDeAtendentesResponse,
  MensagemChamadoResponse,
  PaginaDeChamadosAdminResponse,
  PaginaDeMensagensDeChamadoResponse,
  ResumoDeSuporteAdminResponse,
  TransferirChamadoDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getChamadosAdminControllerResumoUrl = () => {




  return `/v1/admin/chamados/resumo`
}

/**
 * @summary Contadores da fila — alimenta o badge da sidebar
 */
export const chamadosAdminControllerResumo = async ( options?: Parameters<typeof httpClient>[1]): Promise<ResumoDeSuporteAdminResponse> => {

  return httpClient<ResumoDeSuporteAdminResponse>(getChamadosAdminControllerResumoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosAdminControllerResumoQueryKey = () => {
    return [
    `/v1/admin/chamados/resumo`
    ] as const;
    }


export const getChamadosAdminControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosAdminControllerResumoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>> = ({ signal }) => chamadosAdminControllerResumo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosAdminControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>>
export type ChamadosAdminControllerResumoQueryError = unknown


export function useChamadosAdminControllerResumo<TData = Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerResumo<TData = Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerResumo<TData = Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Contadores da fila — alimenta o badge da sidebar
 */

export function useChamadosAdminControllerResumo<TData = Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosAdminControllerResumoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosAdminControllerListarAtendentesUrl = () => {




  return `/v1/admin/chamados/atendentes`
}

/**
 * @summary Quem pode receber uma transferência de chamado
 */
export const chamadosAdminControllerListarAtendentes = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeAtendentesResponse> => {

  return httpClient<ListaDeAtendentesResponse>(getChamadosAdminControllerListarAtendentesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosAdminControllerListarAtendentesQueryKey = () => {
    return [
    `/v1/admin/chamados/atendentes`
    ] as const;
    }


export const getChamadosAdminControllerListarAtendentesQueryOptions = <TData = Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosAdminControllerListarAtendentesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>> = ({ signal }) => chamadosAdminControllerListarAtendentes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosAdminControllerListarAtendentesQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>>
export type ChamadosAdminControllerListarAtendentesQueryError = unknown


export function useChamadosAdminControllerListarAtendentes<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListarAtendentes<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListarAtendentes<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quem pode receber uma transferência de chamado
 */

export function useChamadosAdminControllerListarAtendentes<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarAtendentes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosAdminControllerListarAtendentesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosAdminControllerEnviarAnexoUrl = () => {




  return `/v1/admin/chamados/anexos`
}

/**
 * @summary Envia um anexo para usar depois numa resposta
 */
export const chamadosAdminControllerEnviarAnexo = async (chamadosAdminControllerEnviarAnexoBody: ChamadosAdminControllerEnviarAnexoBody, options?: Parameters<typeof httpClient>[1]): Promise<AnexoDeChamadoResponse> => {
    const formData = new FormData();
if(chamadosAdminControllerEnviarAnexoBody.arquivo !== undefined) {
 formData.append(`arquivo`, chamadosAdminControllerEnviarAnexoBody.arquivo);
 }

  return httpClient<AnexoDeChamadoResponse>(getChamadosAdminControllerEnviarAnexoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getChamadosAdminControllerEnviarAnexoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>, TError,{data: ChamadosAdminControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>, TError,{data: ChamadosAdminControllerEnviarAnexoBody}, TContext> => {

const mutationKey = ['chamadosAdminControllerEnviarAnexo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>, {data: ChamadosAdminControllerEnviarAnexoBody}> = (props) => {
          const {data} = props ?? {};

          return  chamadosAdminControllerEnviarAnexo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerEnviarAnexoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>>
    export type ChamadosAdminControllerEnviarAnexoMutationBody = ChamadosAdminControllerEnviarAnexoBody
    export type ChamadosAdminControllerEnviarAnexoMutationError = unknown

    /**
 * @summary Envia um anexo para usar depois numa resposta
 */
export const useChamadosAdminControllerEnviarAnexo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>, TError,{data: ChamadosAdminControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerEnviarAnexo>>,
        TError,
        {data: ChamadosAdminControllerEnviarAnexoBody},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerEnviarAnexoMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerListarUrl = (params?: ChamadosAdminControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/chamados?${stringifiedParams}` : `/v1/admin/chamados`
}

/**
 * @summary Fila de chamados de todos os ambientes. Ordem padrão: urgência desc, mais antigo primeiro
 */
export const chamadosAdminControllerListar = async (params?: ChamadosAdminControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeChamadosAdminResponse> => {

  return httpClient<PaginaDeChamadosAdminResponse>(getChamadosAdminControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosAdminControllerListarQueryKey = (params?: ChamadosAdminControllerListarParams,) => {
    return [
    `/v1/admin/chamados`, ...(params ? [params] : [])
    ] as const;
    }


export const getChamadosAdminControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError = unknown>(params?: ChamadosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosAdminControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosAdminControllerListar>>> = ({ signal }) => chamadosAdminControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosAdminControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerListar>>>
export type ChamadosAdminControllerListarQueryError = unknown


export function useChamadosAdminControllerListar<TData = Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError = unknown>(
 params: undefined |  ChamadosAdminControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListar<TData = Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError = unknown>(
 params?: ChamadosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListar>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListar<TData = Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError = unknown>(
 params?: ChamadosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fila de chamados de todos os ambientes. Ordem padrão: urgência desc, mais antigo primeiro
 */

export function useChamadosAdminControllerListar<TData = Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError = unknown>(
 params?: ChamadosAdminControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosAdminControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosAdminControllerDetalharUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}`
}

/**
 * @summary Detalhe de qualquer chamado — sem exigir tê-lo assumido
 */
export const chamadosAdminControllerDetalhar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerDetalharUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosAdminControllerDetalharQueryKey = (id: string,) => {
    return [
    `/v1/admin/chamados/${id}`
    ] as const;
    }


export const getChamadosAdminControllerDetalharQueryOptions = <TData = Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosAdminControllerDetalharQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>> = ({ signal }) => chamadosAdminControllerDetalhar(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosAdminControllerDetalharQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>>
export type ChamadosAdminControllerDetalharQueryError = ErroResponse


export function useChamadosAdminControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalhe de qualquer chamado — sem exigir tê-lo assumido
 */

export function useChamadosAdminControllerDetalhar<TData = Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerDetalhar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosAdminControllerDetalharQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosAdminControllerListarMensagensUrl = (id: string,
    params?: ChamadosAdminControllerListarMensagensParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/chamados/${id}/mensagens?${stringifiedParams}` : `/v1/admin/chamados/${id}/mensagens`
}

/**
 * @summary Conversa do chamado
 */
export const chamadosAdminControllerListarMensagens = async (id: string,
    params?: ChamadosAdminControllerListarMensagensParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeMensagensDeChamadoResponse> => {

  return httpClient<PaginaDeMensagensDeChamadoResponse>(getChamadosAdminControllerListarMensagensUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getChamadosAdminControllerListarMensagensQueryKey = (id: string,
    params?: ChamadosAdminControllerListarMensagensParams,) => {
    return [
    `/v1/admin/chamados/${id}/mensagens`, ...(params ? [params] : [])
    ] as const;
    }


export const getChamadosAdminControllerListarMensagensQueryOptions = <TData = Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError = unknown>(id: string,
    params?: ChamadosAdminControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getChamadosAdminControllerListarMensagensQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>> = ({ signal }) => chamadosAdminControllerListarMensagens(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ChamadosAdminControllerListarMensagensQueryResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>>
export type ChamadosAdminControllerListarMensagensQueryError = unknown


export function useChamadosAdminControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError = unknown>(
 id: string,
    params: undefined |  ChamadosAdminControllerListarMensagensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosAdminControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>,
          TError,
          Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useChamadosAdminControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosAdminControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Conversa do chamado
 */

export function useChamadosAdminControllerListarMensagens<TData = Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError = unknown>(
 id: string,
    params?: ChamadosAdminControllerListarMensagensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof chamadosAdminControllerListarMensagens>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getChamadosAdminControllerListarMensagensQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getChamadosAdminControllerEnviarMensagemUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/mensagens`
}

/**
 * @summary Responde no chamado. `aguardarSolicitante` devolve a bola para quem abriu
 */
export const chamadosAdminControllerEnviarMensagem = async (id: string,
    enviarMensagemChamadoAdminDto: EnviarMensagemChamadoAdminDto, options?: Parameters<typeof httpClient>[1]): Promise<MensagemChamadoResponse> => {

  return httpClient<MensagemChamadoResponse>(getChamadosAdminControllerEnviarMensagemUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(enviarMensagemChamadoAdminDto)
  }
);}





export const getChamadosAdminControllerEnviarMensagemMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoAdminDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoAdminDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerEnviarMensagem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>, {id: string;data: EnviarMensagemChamadoAdminDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerEnviarMensagem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerEnviarMensagemMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>>
    export type ChamadosAdminControllerEnviarMensagemMutationBody = EnviarMensagemChamadoAdminDto
    export type ChamadosAdminControllerEnviarMensagemMutationError = ErroResponse

    /**
 * @summary Responde no chamado. `aguardarSolicitante` devolve a bola para quem abriu
 */
export const useChamadosAdminControllerEnviarMensagem = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>, TError,{id: string;data: EnviarMensagemChamadoAdminDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerEnviarMensagem>>,
        TError,
        {id: string;data: EnviarMensagemChamadoAdminDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerEnviarMensagemMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerAssumirUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/assumir`
}

/**
 * @summary Pega o chamado para si — ABERTO vira EM_ANDAMENTO
 */
export const chamadosAdminControllerAssumir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerAssumirUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getChamadosAdminControllerAssumirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>, TError,{id: string}, TContext> => {

const mutationKey = ['chamadosAdminControllerAssumir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  chamadosAdminControllerAssumir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerAssumirMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>>

    export type ChamadosAdminControllerAssumirMutationError = ErroResponse

    /**
 * @summary Pega o chamado para si — ABERTO vira EM_ANDAMENTO
 */
export const useChamadosAdminControllerAssumir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerAssumir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerAssumirMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerMarcarComoLidoUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/leitura`
}

/**
 * @summary Marca o chamado como lido até agora
 */
export const chamadosAdminControllerMarcarComoLido = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getChamadosAdminControllerMarcarComoLidoUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getChamadosAdminControllerMarcarComoLidoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>, TError,{id: string}, TContext> => {

const mutationKey = ['chamadosAdminControllerMarcarComoLido'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  chamadosAdminControllerMarcarComoLido(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerMarcarComoLidoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>>

    export type ChamadosAdminControllerMarcarComoLidoMutationError = unknown

    /**
 * @summary Marca o chamado como lido até agora
 */
export const useChamadosAdminControllerMarcarComoLido = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerMarcarComoLido>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerMarcarComoLidoMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerDefinirUrgenciaUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/urgencia`
}

/**
 * @summary Reclassifica a urgência declarada pelo solicitante
 */
export const chamadosAdminControllerDefinirUrgencia = async (id: string,
    definirUrgenciaDto: DefinirUrgenciaDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerDefinirUrgenciaUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirUrgenciaDto)
  }
);}





export const getChamadosAdminControllerDefinirUrgenciaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>, TError,{id: string;data: DefinirUrgenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>, TError,{id: string;data: DefinirUrgenciaDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerDefinirUrgencia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>, {id: string;data: DefinirUrgenciaDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerDefinirUrgencia(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerDefinirUrgenciaMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>>
    export type ChamadosAdminControllerDefinirUrgenciaMutationBody = DefinirUrgenciaDto
    export type ChamadosAdminControllerDefinirUrgenciaMutationError = unknown

    /**
 * @summary Reclassifica a urgência declarada pelo solicitante
 */
export const useChamadosAdminControllerDefinirUrgencia = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>, TError,{id: string;data: DefinirUrgenciaDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerDefinirUrgencia>>,
        TError,
        {id: string;data: DefinirUrgenciaDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerDefinirUrgenciaMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerDefinirPrevisaoUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/previsao`
}

/**
 * @summary Define (ou limpa, com null) a previsão de conclusão prometida ao solicitante
 */
export const chamadosAdminControllerDefinirPrevisao = async (id: string,
    definirPrevisaoDto: DefinirPrevisaoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerDefinirPrevisaoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirPrevisaoDto)
  }
);}





export const getChamadosAdminControllerDefinirPrevisaoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>, TError,{id: string;data: DefinirPrevisaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>, TError,{id: string;data: DefinirPrevisaoDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerDefinirPrevisao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>, {id: string;data: DefinirPrevisaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerDefinirPrevisao(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerDefinirPrevisaoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>>
    export type ChamadosAdminControllerDefinirPrevisaoMutationBody = DefinirPrevisaoDto
    export type ChamadosAdminControllerDefinirPrevisaoMutationError = ErroResponse

    /**
 * @summary Define (ou limpa, com null) a previsão de conclusão prometida ao solicitante
 */
export const useChamadosAdminControllerDefinirPrevisao = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>, TError,{id: string;data: DefinirPrevisaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerDefinirPrevisao>>,
        TError,
        {id: string;data: DefinirPrevisaoDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerDefinirPrevisaoMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerAgendarCorrecaoUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/correcao`
}

/**
 * @summary Registra a data em que a correção sobe para produção (ou limpa, com null)
 */
export const chamadosAdminControllerAgendarCorrecao = async (id: string,
    agendarCorrecaoDto: AgendarCorrecaoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerAgendarCorrecaoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agendarCorrecaoDto)
  }
);}





export const getChamadosAdminControllerAgendarCorrecaoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>, TError,{id: string;data: AgendarCorrecaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>, TError,{id: string;data: AgendarCorrecaoDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerAgendarCorrecao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>, {id: string;data: AgendarCorrecaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerAgendarCorrecao(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerAgendarCorrecaoMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>>
    export type ChamadosAdminControllerAgendarCorrecaoMutationBody = AgendarCorrecaoDto
    export type ChamadosAdminControllerAgendarCorrecaoMutationError = ErroResponse

    /**
 * @summary Registra a data em que a correção sobe para produção (ou limpa, com null)
 */
export const useChamadosAdminControllerAgendarCorrecao = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>, TError,{id: string;data: AgendarCorrecaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerAgendarCorrecao>>,
        TError,
        {id: string;data: AgendarCorrecaoDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerAgendarCorrecaoMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerConcluirUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/concluir`
}

/**
 * @summary Conclui o chamado. A resolução é obrigatória e vira a última linha da conversa
 */
export const chamadosAdminControllerConcluir = async (id: string,
    concluirChamadoDto: ConcluirChamadoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerConcluirUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(concluirChamadoDto)
  }
);}





export const getChamadosAdminControllerConcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>, TError,{id: string;data: ConcluirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>, TError,{id: string;data: ConcluirChamadoDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerConcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>, {id: string;data: ConcluirChamadoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerConcluir(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerConcluirMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>>
    export type ChamadosAdminControllerConcluirMutationBody = ConcluirChamadoDto
    export type ChamadosAdminControllerConcluirMutationError = ErroResponse

    /**
 * @summary Conclui o chamado. A resolução é obrigatória e vira a última linha da conversa
 */
export const useChamadosAdminControllerConcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>, TError,{id: string;data: ConcluirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerConcluir>>,
        TError,
        {id: string;data: ConcluirChamadoDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerConcluirMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerTransferirUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/transferir`
}

/**
 * @summary Passa o chamado para outro atendente
 */
export const chamadosAdminControllerTransferir = async (id: string,
    transferirChamadoDto: TransferirChamadoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerTransferirUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferirChamadoDto)
  }
);}





export const getChamadosAdminControllerTransferirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>, TError,{id: string;data: TransferirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>, TError,{id: string;data: TransferirChamadoDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerTransferir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>, {id: string;data: TransferirChamadoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerTransferir(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerTransferirMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>>
    export type ChamadosAdminControllerTransferirMutationBody = TransferirChamadoDto
    export type ChamadosAdminControllerTransferirMutationError = ErroResponse

    /**
 * @summary Passa o chamado para outro atendente
 */
export const useChamadosAdminControllerTransferir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>, TError,{id: string;data: TransferirChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerTransferir>>,
        TError,
        {id: string;data: TransferirChamadoDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerTransferirMutationOptions(options), queryClient);
    }
    export const getChamadosAdminControllerCancelarUrl = (id: string,) => {




  return `/v1/admin/chamados/${id}/cancelar`
}

/**
 * @summary Cancela o chamado (spam, duplicata). Diferente de concluir: não houve atendimento
 */
export const chamadosAdminControllerCancelar = async (id: string,
    cancelarChamadoDto: CancelarChamadoDto, options?: Parameters<typeof httpClient>[1]): Promise<ChamadoAdminResponse> => {

  return httpClient<ChamadoAdminResponse>(getChamadosAdminControllerCancelarUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(cancelarChamadoDto)
  }
);}





export const getChamadosAdminControllerCancelarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>, TError,{id: string;data: CancelarChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>, TError,{id: string;data: CancelarChamadoDto}, TContext> => {

const mutationKey = ['chamadosAdminControllerCancelar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>, {id: string;data: CancelarChamadoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  chamadosAdminControllerCancelar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChamadosAdminControllerCancelarMutationResult = NonNullable<Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>>
    export type ChamadosAdminControllerCancelarMutationBody = CancelarChamadoDto
    export type ChamadosAdminControllerCancelarMutationError = unknown

    /**
 * @summary Cancela o chamado (spam, duplicata). Diferente de concluir: não houve atendimento
 */
export const useChamadosAdminControllerCancelar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>, TError,{id: string;data: CancelarChamadoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof chamadosAdminControllerCancelar>>,
        TError,
        {id: string;data: CancelarChamadoDto},
        TContext
      > => {
      return useMutation(getChamadosAdminControllerCancelarMutationOptions(options), queryClient);
    }
